// private plugins registry.
const PLUGINS = new Map();

// instantiate plugins from configuration:
function createAllPlugins(app, meta = []) {

    if (!meta || !Array.isArray(meta)) {
        throw new Error(`No metadata array for plugins`);
    }

    return meta.filter(m=>!m.disabled).map(m=>{

        const id = m.id;

        if (!id) {
            throw new Error(`No ID for plugin`);
        }

        const ctor = m.type;
        if (!ctor) {
            throw new Error(`No type for plugin ${id}`);
        }

        // create
        const plugin = new ctor(id, app, m);

        // register
        PLUGINS.set(id, plugin);

        return plugin;
    });
}

/**
 * An Application class singleton that represents the system as a whole.
 * Basically, It is just a container for plugins: creates/configures set of them and manages its life-cycle `init/done()`
 * Various plugins may feature the application instance with some additional functionality (like eventing, logging etc.)
 *
 * @see ./Plugin.js
 */
export default class Application {

    constructor(config) {

        this._config = {...config};

        createAllPlugins(this, this.config('plugins'));
    }

    /**
     *  Initializes the application.
     *
     *  TO be invoked immediately after app instance is created.
     */
    async init() {

        await this.forEachPlugin(p => p.resolveDependencies && p.resolveDependencies(PLUGINS));

        // init plugins
        return await this.forEachPlugin(p => p.init && p.init());
    }

    /**
     *  Finalizes the application.
     *
     *  TO be invoked when process is stopped.
     */
    async done() {

        // done plugins
        return await this.forEachPlugin(p => p.done && p.done());
    }

    //////////////////////
    // Routines
    /////////////////////

    async forEachPlugin(op) {

        for (let plugin of PLUGINS.values()) {

            await op.call(plugin, plugin);
        }

        return this;
    }

    config(key) {

        return key && this._config[key] || null;
    }
}